import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { HERITAGE_ASSETS, api } from '@/lib/api';
import { Panel, SectionDivider } from '@/components/Panel';
import { HeritageSeal } from '@/components/BrandMark';

export function CatalogContent({ compact = false }) {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/catalog-items');
        setItems(data.items || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoaded(true);
      }
    })();
  }, []);

  return (
    <div>
      {!compact && (
        <div className="relative w-full overflow-hidden" style={{ background: '#4B1838' }}>
          <img
            src={HERITAGE_ASSETS.heroSubBanner}
            alt="Heritage catalogue"
            className="w-full max-h-[520px] object-cover"
            style={{ objectPosition: 'center top' }}
          />
        </div>
      )}

      <div className="max-w-6xl mx-auto px-6 pt-10 text-center">
        <HeritageSeal size={72} />
        <div className="h-eyebrow mt-4">The Catalogue</div>
        <h1 className="h-display text-5xl mt-2" style={{ color: 'var(--heritage-plum)' }}>Heritage Original Collection</h1>
        <p className="opacity-85 max-w-2xl mx-auto mt-3" style={{ color: 'var(--heritage-plum)' }}>
          Every garment in the Heritage Original Collection is cut and embroidered in small batches. This is our founding release. It is not restocked.
        </p>
      </div>

      <SectionDivider label="Signature garments" />

      <div className="max-w-6xl mx-auto px-6 pb-10 space-y-10">
        {loaded && items.length === 0 && (
          <Panel className="p-10 text-center">
            <div className="h-serif text-2xl" style={{ color: 'var(--heritage-plum)' }}>Catalogue coming soon</div>
            <div className="text-sm opacity-80 mt-2" style={{ color: 'var(--heritage-plum)' }}>Heritage is preparing the next release.</div>
          </Panel>
        )}
        {items.map((item, idx) => (
          <Panel key={item.id} className="p-3 overflow-hidden" data-testid={`catalog-item-${item.slug}`}>
            <div className={`grid md:grid-cols-2 gap-0 ${idx % 2 === 1 ? 'md:[direction:rtl]' : ''}`}>
              <img
                src={item.image_base64 ? (item.image_base64.startsWith('data:') ? item.image_base64 : `data:image/png;base64,${item.image_base64}`) : (item.image_url || HERITAGE_ASSETS.editorial)}
                alt={item.name}
                className="w-full h-full object-cover rounded-lg"
                style={{ direction: 'ltr' }}
              />
              <div className="p-6 md:p-8 flex flex-col justify-center" style={{ direction: 'ltr' }}>
                <div className="h-eyebrow">{item.subtitle}</div>
                <div className="h-serif text-3xl md:text-4xl mt-1" style={{ color: 'var(--heritage-plum)' }}>{item.name}</div>
                {item.description && (
                  <p className="text-sm opacity-85 mt-2" style={{ color: 'var(--heritage-plum)' }}>{item.description}</p>
                )}
                <div className="h-divider my-4" />
                <ul className="space-y-2 text-sm" style={{ color: 'var(--heritage-plum)' }}>
                  {(item.highlights || []).map((h) => (
                    <li key={h} className="flex gap-2"><span>◈</span><span>{h}</span></li>
                  ))}
                </ul>
                <div className="flex items-baseline justify-between mt-5">
                  <div>
                    <div className="h-eyebrow">from</div>
                    <div className="h-serif text-2xl" style={{ color: 'var(--heritage-plum)' }}>${item.price} {item.currency || 'NZD'}</div>
                  </div>
                  {item.founder_first && (
                    <span className="h-chip" style={{ background: 'rgba(154,75,126,0.15)', borderColor: 'rgba(154,75,126,0.35)', color: 'var(--heritage-plum)' }}>
                      Available to founders first
                    </span>
                  )}
                </div>
                <div className="mt-4">
                  <Link to={`/catalog/${item.slug}`} className="h-btn text-xs" data-testid={`catalog-view-${item.slug}`}>
                    View full details
                  </Link>
                </div>
              </div>
            </div>
          </Panel>
        ))}
      </div>

      <SectionDivider label="Signature colours" />

      <div className="max-w-6xl mx-auto px-6 pb-16">
        <Panel className="p-3">
          <img src={HERITAGE_ASSETS.swatches} alt="Signature Colours" className="w-full rounded-xl" />
        </Panel>
      </div>
    </div>
  );
}

export default function CatalogPage() {
  return <CatalogContent />;
}
